import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { MessengerService } from '@services/messenger/messenger.service';
import { MyOrganisationService } from '@services/organisations/my-organisation.service';
import { Observable } from 'rxjs';

@Injectable()
export class OrganisationGuard  {

  constructor(
    private messengerService: MessengerService,
    private myOrganisationService: MyOrganisationService,
    private router: Router
  ) {
  }

  private async checkOrganisation(route, state: RouterStateSnapshot): Promise<any> {
    const organisationName = route.queryParams?.['swap_org'] ? decodeURIComponent(route.queryParams['swap_org']) : /\(org:(\S+)(\)|\/)/.exec(state.url) ? decodeURIComponent(/\(org:(\S+)(\)|\/)/.exec(state.url)[1]) : null;
    const currentOrg = this.messengerService.getOrganisation();
    const activeSession = this.messengerService.$activeSession.getValue();
    if (organisationName && (!currentOrg || organisationName !== currentOrg.name)) {
      if (!activeSession) {
        return new Promise(resolve => setTimeout(() => resolve(this.checkOrganisation(route, state)), 500));
      }
      try {
        const result = await this.myOrganisationService.find(0, 1, { name: organisationName });
        if (!result?.data?.length) {
          setTimeout(() => this.router.navigateByUrl('organisationNotAvailable'), 0);
          return false;
        }
        this.messengerService.setOrganisation(result.data[0]);
        return true;
      } catch (err) {
        console.warn(err);
        return false;
      }
    }
    if (!organisationName && !currentOrg) {
      setTimeout(() => this.router.navigateByUrl('selectOrganisation'), 0);
      return false;
    }
    return true;
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkOrganisation(route, state);
  }
}
